import { Slider } from "@material-ui/core"
import React, { useEffect, useState } from "react"
import * as styles from "./GeocodeRadius.module.scss"
import { GEOLOCATION_DEFAULT_RADIUS } from "@data/constants"

const GeocodeRadius = ({ updateResults, filters }) => {
  const [radius, setRadius] = useState(GEOLOCATION_DEFAULT_RADIUS)
  const [radiusInput, setRadiusInput] = useState(GEOLOCATION_DEFAULT_RADIUS)

  // no postcode and filters exist then load from param
  useEffect(() => {
    if (filters.location && filters.location.radius) {
      setRadius(filters.location.radius)
      setRadiusInput(reverseValue(filters.location.radius))
    }
  }, [])

  // track when valid postcode or intentionally no postcode and update filters
  useEffect(async () => {
    if (filters && filters.location && filters.location.latitude) {
      const currRadius = filters && filters.location ? filters.location.radius : 0
      if (radius !== currRadius) {
        await updateResults({
          ...filters,
          location: {
            ...filters.location,
            radius,
          },
        })
      }
    }
  }, [radius])

  const marks = [
    {
      value: 1,
      label: "1mi",
    },
    {
      value: 50,
      label: "50mi",
    },
    {
      value: 65,
      label: "200mi",
    },
  ]

  const calcValue = (x) => {
    if (x <= 50) {
      return x
    }
    if (x > 50) {
      return (x - 50) * 10 + 50
    }
  }
  const reverseValue = (x) => {
    if (x > 50) {
      return (x - 50) / 10 + 50
    }
    return x
  }

  return (
    <div className={styles.GeocodeRadius}>
      <Slider
        aria-labelledby="discrete-slider-small-steps"
        // marks={marks}
        classes={{
          root: styles.root,
          track: styles.track,
          rail: styles.rail,
          mark: styles.mark,
          thumb: styles.thumb,
          valueLabel: styles.valueLabel,
          active: "",
          markLabel: styles.markLabel,
        }}
        onChange={(event, value) => setRadiusInput(value)}
        onChangeCommitted={(event, value) => setRadius(calcValue(value))}
        min={1}
        max={65}
        scale={calcValue}
        aria-label="location range slider"
        value={radiusInput}
        valueLabelDisplay="on"
      />
    </div>
  )
}

export default GeocodeRadius
